/* Attribute only this product's real experiment visits; reuse the existing commerce form. */
function init10502bAttribution(root) {
  if (root.dataset.productId !== '7191489478705' || root.dataset.abAttributionReady) return;
  const form = root.querySelector('form.product-single__form');
  if (!form) return;
  root.dataset.abAttributionReady = 'true';
  const contextKey = 'zg:purchase-exposure:7191489478705';
  const fields = {};
  ['_zg_ab_id', '_zg_ab_variant', '_zg_ab_exposed_at', '_zg_ab_expires_at', '_zg_ab_origin', '_zg_ab_test', '_zg_ab_excluded'].forEach((key) => {
    const input = document.createElement('input');
    input.type = 'hidden';
    input.name = 'properties[' + key + ']';
    input.disabled = true;
    form.append(input);
    fields[key] = input;
  });
  let attempts = 0;
  let timer;
  const sync = () => {
    clearTimeout(timer);
    if (!root.isConnected) {
      document.removeEventListener('zg:consent-state', sync);
      document.removeEventListener('visibilitychange', sync);
      return;
    }
    Object.values(fields).forEach((input) => { input.disabled = true; });
    let allowed = false;
    try { allowed = window.ZGConsentTracking?.state().analytics === true; } catch (error) { /* No consent signal: no attribution. */ }
    if (!allowed) {
      try { window.localStorage.removeItem(contextKey); } catch (error) { /* Storage can be blocked. */ }
      return;
    }
    const experimentId = root.dataset.experimentId;
    const variant = root.dataset.purchaseVersion;
    const qa = root.dataset.experimentMode === 'qa' && experimentId === '10502b_qa_20261022';
    if (!qa && (root.dataset.experimentMode !== 'assigned' || !/^10502b_v[1-9][0-9]*$/.test(experimentId))) {
      fields._zg_ab_excluded.value = root.dataset.experimentMode || 'off';
      fields._zg_ab_excluded.disabled = false;
      try { window.localStorage.setItem(contextKey, JSON.stringify({ mode: 'excluded' })); } catch (error) { /* No analytics fallback. */ }
      return;
    }
    let assignment;
    let previous;
    try {
      assignment = JSON.parse(window.localStorage.getItem('zg:purchase-experiment:' + experimentId));
      try { previous = JSON.parse(window.localStorage.getItem(contextKey)); } catch (error) { previous = null; }
    } catch (error) { return; }
    const now = Date.now();
    if (!assignment || assignment.version !== variant || assignment.expiresAt <= now) return;
    const exposedAt = previous?.mode === 'assigned' && previous.experimentId === experimentId && previous.variant === variant &&
      Number.isFinite(previous.exposedAt) && previous.exposedAt <= now && previous.expiresAt === assignment.expiresAt ? previous.exposedAt : now;
    const context = { mode: 'assigned', productId: '7191489478705', experimentId, variant, exposedAt, expiresAt: assignment.expiresAt, origin: window.location.hostname, qa };
    try { window.localStorage.setItem(contextKey, JSON.stringify(context)); } catch (error) { return; }
    const values = { _zg_ab_id: experimentId, _zg_ab_variant: variant, _zg_ab_exposed_at: exposedAt, _zg_ab_expires_at: assignment.expiresAt, _zg_ab_origin: window.location.hostname, _zg_ab_test: qa ? '1' : '0' };
    Object.entries(values).forEach(([key, value]) => { fields[key].value = String(value); fields[key].disabled = false; });
    // A page exposure is sent through the same Shopify pixel as all commerce events.
    // Keep the page key across CLI section replacements, but not across page navigation.
    window.zg10502bExposurePages = window.zg10502bExposurePages || {};
    const pageKey = experimentId + ':' + variant;
    const page = window.zg10502bExposurePages[pageKey] || (window.zg10502bExposurePages[pageKey] = { id: window.crypto.randomUUID(), published: false });
    if (page.published || (!qa && document.visibilityState !== 'visible')) return;
    if (window.Shopify?.analytics?.publish) {
      try {
        page.published = window.Shopify.analytics.publish('zg:ab_exposure', { ...context, pageExposureId: page.id }) !== false;
      } catch (error) { page.published = false; }
    }
    if (!page.published && attempts++ < 20) timer = setTimeout(sync, 500);
  };
  sync();
  document.addEventListener('zg:consent-state', sync);
  document.addEventListener('visibilitychange', sync);
  // Capture precedes both the theme Ajax handler and the bundle Ajax handler.
  form.addEventListener('submit', sync, true);
  root.addEventListener('buy-preview:ready', sync);
}

/* Display the shared accessory selection total in this product layout. */
function init10502bTotals(scope) {
  scope.querySelectorAll(".zg-product-buy").forEach((root) => {
    window.zg10502bExperiment?.(root);
    init10502bAttribution(root);
    if (root.dataset.totalsReady) return;
    root.dataset.totalsReady = "true";
    if (root.dataset.forcedPreview) root.addEventListener("variantChange", () => {
      queueMicrotask(() => {
        const url = new URL(window.location.href);
        url.searchParams.set(root.dataset.forcedParam || "ab_preview", root.dataset.forcedPreview);
        window.history.replaceState(window.history.state, "", url);
      });
    });
    const price = root.querySelector("[data-product-price]");
    const totalPrices = root.querySelectorAll(
      "[data-bundle-total-price], .zg-product-buy__selected-price",
    );
    const variantPrices = root.querySelectorAll(".zg-product-buy__variant-price");
    const hasTotals = totalPrices.length || variantPrices.length;

    if (!price) return;

    let basePrice = Number(price.dataset.basePrice || 0);

    let accessoryTotal = 0;

    const formatMoney = (cents) => {
      let formattedMoney;

      if (window.theme?.Currency?.formatMoney) {
        formattedMoney = window.theme.Currency.formatMoney(
          cents,
          window.theme.settings.moneyFormat,
        );
      } else {
        formattedMoney = new Intl.NumberFormat("en-US", {
          style: "currency",
          currency: window.Shopify?.currency?.active || "USD",
        }).format(cents / 100);
      }

      return cents % 100 === 0
        ? formattedMoney.replace(/([.,])00(?!\d)/, "")
        : formattedMoney;
    };

    const updateTotal = () => {
      const formattedTotal = formatMoney(basePrice + accessoryTotal);
      const ctaTotal = root.querySelector("[data-buy-cta-total]");
      if (ctaTotal) ctaTotal.textContent = " – " + formattedTotal;
      totalPrices.forEach((element) => {
        element.textContent = formattedTotal;
      });
      variantPrices.forEach((element) => {
        const selected = element.closest(".variant-input")
          ?.querySelector("[data-variant-input]")?.checked;
        element.textContent = selected && root.dataset.purchaseVersion !== "B"
          ? formattedTotal
          : formatMoney(Number(element.dataset.basePrice || 0));
      });
    };

    if (hasTotals) root.addEventListener("bundle-upsell:change", (event) => {
      accessoryTotal = Number(event.detail.totalCents || 0);
      updateTotal();
    });
    if (hasTotals) root.addEventListener("variantChange", (event) => {
      if (!event.detail.variant) return;
      basePrice = Number(event.detail.variant.price || 0);
      price.dataset.basePrice = String(basePrice);
      queueMicrotask(updateTotal);
    });

    root.addEventListener("buy-preview:ready", updateTotal);
    if (hasTotals) updateTotal();
  });
}
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", () => init10502bTotals(document));
} else {
  init10502bTotals(document);
}
document.addEventListener("shopify:section:load", (event) => init10502bTotals(event.target));
(function () {
  function initDetails(root) {
    if (!root || root.dataset.ready === 'true') return;
    root.dataset.ready = 'true';
    var track = root.querySelector('[data-video-track]');
    var dots = root.querySelectorAll('[data-video-dot]');
    var dragStartX = 0;
    var dragStartScroll = 0;
    var activePointerId = null;
    var dragged = false;
    var currentPlaying = null;
    var stopVideo = function (card) {
      if (!card || !card.dataset.originalContent) return;
      card.innerHTML = card.dataset.originalContent;
      if (currentPlaying === card) currentPlaying = null;
    };
    var playVideo = function (card) {
      if (!card?.dataset.videoId || card.querySelector('iframe')) return;
      if (currentPlaying && currentPlaying !== card) stopVideo(currentPlaying);
      var iframe = document.createElement('iframe');
      iframe.src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(card.dataset.videoId) + '?autoplay=1&rel=0';
      iframe.title = card.dataset.videoTitle || 'Z Grills product video';
      iframe.allow = 'autoplay; encrypted-media; picture-in-picture';
      iframe.allowFullscreen = true;
      card.dataset.originalContent = card.innerHTML;
      card.replaceChildren(iframe);
      currentPlaying = card;
    };

    root.querySelectorAll('[data-video-id]').forEach(function (card) {
      card.addEventListener('click', function () {
        if (dragged) {
          dragged = false;
          return;
        }
        playVideo(card);
      });
      card.addEventListener('keydown', function (event) {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        event.preventDefault();
        card.click();
      });
    });

    if (track) {
      var updateDots = function () {
        var cards = track.querySelectorAll('[data-video-id]');
        if (!cards.length) return;
        var maxScroll = track.scrollWidth - track.clientWidth;
        var page = maxScroll > 0 ? Math.round((track.scrollLeft / maxScroll) * (dots.length - 1)) : 0;
        dots.forEach(function (dot, dotIndex) { dot.classList.toggle('is-active', dotIndex === page); });
      };
      track.addEventListener('pointerdown', function (event) {
        if (event.pointerType === 'touch') return;
        activePointerId = event.pointerId;
        dragStartX = event.clientX;
        dragStartScroll = track.scrollLeft;
        dragged = false;
        track.classList.add('is-dragging');
      });
      track.addEventListener('pointermove', function (event) {
        if (activePointerId !== event.pointerId) return;
        var distance = event.clientX - dragStartX;
        if (Math.abs(distance) > 5) {
          dragged = true;
          if (!track.hasPointerCapture(event.pointerId)) track.setPointerCapture(event.pointerId);
        }
        track.scrollLeft = dragStartScroll - distance;
      });
      var finishDrag = function (event) {
        if (activePointerId !== event.pointerId) return;
        if (track.hasPointerCapture(event.pointerId)) track.releasePointerCapture(event.pointerId);
        activePointerId = null;
        track.classList.remove('is-dragging');
        updateDots();
        window.setTimeout(function () { dragged = false; }, 0);
      };
      track.addEventListener('pointerup', finishDrag);
      track.addEventListener('pointercancel', finishDrag);
      track.addEventListener('scroll', updateDots, { passive: true });
      dots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          var cards = track.querySelectorAll('[data-video-id]');
          var target = cards[parseInt(dot.dataset.videoDot, 10)];
          if (target) track.scrollTo({ left: target.offsetLeft - track.offsetLeft, behavior: 'smooth' });
        });
      });
    }
  }

  function initAll(container) {
    (container || document).querySelectorAll('[data-zg-product-details]').forEach(initDetails);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();
  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
})();

/* Shared B purchase behavior. Assignment is resolved by the section; GA4 uses the existing Shopify pixel. */
(function () {
  function initPriceGuarantee(root) {
    const dialog = root.querySelector('[data-price-guarantee-dialog]');
    const trigger = root.querySelector('.bogt-price-guarantee');
    if (!dialog || !trigger || dialog.dataset.guaranteeReady) return;
    dialog.dataset.guaranteeReady = 'true';
    trigger.addEventListener('click', () => {
      if (!dialog.open) dialog.showModal();
    });
    dialog.querySelector('.bogt-guarantee-close').addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', (event) => {
      if (event.target !== dialog) return;
      const bounds = dialog.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right ||
          event.clientY < bounds.top || event.clientY > bounds.bottom) {
        dialog.close();
      }
    });
    dialog.addEventListener('close', () => {
      if (trigger.isConnected) trigger.focus({ preventScroll: true });
    });
  }
  function initPurchasePreview(root) {
    if (!root) return;
    initPriceGuarantee(root);
    window.zg10502bExperiment?.(root);
    if (root.dataset.buyPreviewReady || root.dataset.purchaseVersion !== 'B') return;
    root.dataset.buyPreviewReady = 'true';
    // Match the demo's estimate exactly: 3 business days processing, then 3–8 shipping.
    // This is a browser-local estimate, excludes weekends, and is not a carrier quote.
    const deliveryDate = root.querySelector('[data-buy-delivery-date]');
    if (deliveryDate) {
      const addBusinessDays = (from, days) => {
        const date = new Date(from);
        let added = 0;
        while (added < days) {
          date.setDate(date.getDate() + 1);
          if (date.getDay() !== 0 && date.getDay() !== 6) added++;
        }
        return date;
      };
      const processingEnd = addBusinessDays(new Date(), 3);
      const formatDate = (date) => date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
      deliveryDate.textContent = 'Est. ' + formatDate(addBusinessDays(processingEnd, 3)) + ' – ' + formatDate(addBusinessDays(processingEnd, 8));
    }
    const information = root.querySelector('[data-buy-information]');
    const tabs = Array.from(information.querySelectorAll('[data-buy-tab]'));
    const panels = Array.from(information.querySelectorAll('[data-buy-panel]'));
    const more = information.querySelector('[data-buy-more]');
    let activePanel = panels[0];
    let expanded = false;
    function refreshMore() {
      const copy = activePanel.querySelector('[data-buy-tab-copy]');
      panels.forEach((panel) => {
        panel.querySelector('[data-buy-tab-copy]').classList.toggle('is-expanded', expanded);
        const panelExtra = panel.querySelector('[data-buy-extra]');
        if (panelExtra) panelExtra.hidden = !expanded;
      });
      const extra = activePanel.querySelector('[data-buy-extra]');
      const overflowing = copy.scrollHeight > copy.clientHeight + 1;
      copy.classList.toggle('has-overflow', !expanded && overflowing);
      if (extra) extra.hidden = !expanded;
      more.hidden = !extra && !expanded && !overflowing;
      more.setAttribute('aria-expanded', String(expanded));
      more.setAttribute('aria-controls', panels.map((panel) => panel.id).join(' '));
      more.querySelector('[data-buy-more-label]').textContent = expanded ? 'See less' : 'See more';
    }
    function activate(tab, focus) {
      tabs.forEach((item) => {
        const selected = item === tab;
        item.setAttribute('aria-selected', String(selected));
        item.tabIndex = selected ? 0 : -1;
      });
      panels.forEach((panel) => {
        panel.hidden = panel.dataset.buyPanel !== tab.dataset.buyTab;
        if (!panel.hidden) activePanel = panel;
      });
      if (focus) tab.focus();
      refreshMore();
    }
    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => activate(tab));
      tab.addEventListener('keydown', (event) => {
        let next;
        if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
        if (event.key === 'ArrowLeft') next = (index + tabs.length - 1) % tabs.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = tabs.length - 1;
        if (next === undefined) return;
        event.preventDefault();
        activate(tabs[next], true);
      });
    });
    more.addEventListener('click', () => {
      expanded = !expanded;
      refreshMore();
    });
    if (window.ResizeObserver) new ResizeObserver(refreshMore).observe(information);
    refreshMore();

    const addButton = root.querySelector('[data-add-to-cart]');
    if (addButton && !addButton.querySelector('[data-buy-cta-total]')) {
      const total = document.createElement('span');
      total.className = 'zg-buy-b-only zg-buy-b__cta-total';
      total.dataset.buyCtaTotal = '';
      total.setAttribute('aria-live', 'polite');
      addButton.append(total);
    }
    const bundle = root.querySelector('[data-bundle-upsell]');
    function updateIncludedAccessories(variant) {
      // The cover variant already contains a grill cover. Preserve all other accessory rules.
      const includesCover = /\bcover\b/i.test(variant.title || '');
      let changed = false;
      bundle?.querySelectorAll('[data-bundle-option]').forEach((option) => {
        const checkbox = option.querySelector('[data-bundle-checkbox]');
        const name = option.querySelector('.bundle-upsell__name')?.textContent || '';
        const included = includesCover && /\bcover\b/i.test(name);
        option.classList.toggle('is-included', included);
        checkbox.disabled = included;
        if (included && checkbox.checked) { checkbox.checked = false; changed = true; }
      });
      if (changed) bundle.dispatchEvent(new Event('change', { bubbles: true }));
      root.querySelectorAll('[data-buy-variant-content]').forEach((element) => {
        element.hidden = element.dataset.buyVariantContent !== String(variant.id);
      });
    }
    root.addEventListener('variantChange', (event) => {
      if (event.detail.variant) updateIncludedAccessories(event.detail.variant);
    });
    // Variant data is scoped explicitly to this preview, independent of theme internals.
    const previewJson = root.querySelector('[data-buy-variants]');
    if (previewJson) {
      const variants = JSON.parse(previewJson.textContent);
      const selectedId = root.querySelector('select[name="id"], input[name="id"]')?.value;
      updateIncludedAccessories(variants.find((variant) => String(variant.id) === selectedId) || variants.find((variant) => variant.available) || variants[0]);
    }
    root.dispatchEvent(new CustomEvent('buy-preview:ready'));
  }
  function init(scope) { scope.querySelectorAll('.zg-product-buy').forEach(initPurchasePreview); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document));
  else init(document);
  document.addEventListener('shopify:section:load', (event) => init(event.target));
  // Shopify CLI can replace section HTML without executing its inline scripts.
  if (!window.zg10502bSectionObserver) {
    window.zg10502bSectionObserver = new MutationObserver((records) => {
      records.forEach((record) => record.addedNodes.forEach((node) => {
        if (node.nodeType !== 1) return;
        const roots = node.matches('.zg-product-buy') ? [node] : node.querySelectorAll('.zg-product-buy');
        roots.forEach((root) => {
          init10502bTotals(root.parentElement);
          initPurchasePreview(root);
        });
      }));
    });
    window.zg10502bSectionObserver.observe(document.documentElement, { childList: true, subtree: true });
  }
})();
